import { type Meta } from '@air/analytics';

const META: Meta = {
  description: 'User viewed a board',
  name: 'viewed_board',
  params: [
    {
      description: 'The id of the board',
      name: 'board_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
